import { Typography } from 'antd';

const { Text } = Typography;
const EllipsisText = ({
  text = '',
  tooltip,
  width,
}: {
  text?: string;
  tooltip?: React.ReactNode;
  width?: string | number;
}) => {
  return (
    <Text
      style={{ width: width || '100%' }}
      ellipsis={{
        tooltip: tooltip || text,
      }}
    >
      {text}
    </Text>
  );
};
export default EllipsisText;
